import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import CreateTemplateModal from './CreateTemplateModal';

import classes from './inventoryExport.module.css';

interface Props {
  navigateBack: () => void;
  loading: boolean;
}

const InventoryExportPortalHeader = ({ navigateBack, loading }: Props) => {
  return (
    <div className={classes.navigationBarContainer}>
      <div className={classes.backNavigationContainer} onClick={navigateBack}>
        <div className={classes.backButtonIcon}>
          <Icon color={colors.neutral.white}>arrow_back</Icon>
        </div>
        <div className={classes.backButtonText}>Exports</div>
      </div>
      <CreateTemplateModal loading={loading} />
    </div>
  );
};

export default InventoryExportPortalHeader;
